import { defineAsyncComponent } from 'vue';

export { default as TimeSpotterHeader } from './components/TimeSpotter/TimeSpotterHeader.vue';
export { default as TimeSpotterBody } from './components/TimeSpotter/TimeSpotterBody.vue';
export { default as TimeSpotterSlotButtons } from './components/TimeSpotter/TimeSpotterSlotButtons.vue';
export { default as TimeSpotterUpgradeMessage } from './components/TimeSpotter/TimeSpotterUpgradeMessage.vue';
export { default as TimeOffListPopover } from './components/TimeOff/TimeOffListPopover.vue';

export * from './components/TimeSpotter/types';

export const calendarMicroFrontends = {
	TimeSpotter: defineAsyncComponent(
		() => import('./components/TimeSpotter/TimeSpotter.vue')
	),
	TimeOff: defineAsyncComponent(
		() => import('./components/TimeOff/TimeOff.vue')
	),
	TimeOffListPopover: defineAsyncComponent(
		() => import('./components/TimeOff/TimeOffListPopover.vue')
	),
};
